import api from "services/api";
import logger from "utils/logger";
import util from "utils/util";
import date from "utils/date";
import notifier from "utils/notifier";

let token = "";

const setToken = (newToken) => {
  token = newToken;
  logger.dataLog("设置令牌：", token);
};

const removeToken = () => {
  token = "";
  logger.dataLog("移除令牌：", token);
};

// 获取插件信息列表 和模糊匹配
const getPluginInfoList = async (pageSize, currentPage, keyword) => {
  let resData = {};
  if (keyword) {
    const filter = { match: keyword };
    resData = await api.queryPluginInfo(pageSize, currentPage - 1, filter);
  } else {
    resData = await api.queryPluginInfo(pageSize, currentPage - 1);
  }

  if (resData.code !== 0) {
    logger.error("getPluginInfos code：", resData.code, " resData: ", resData);
    throw new Error("查询插件信息失败");
  }

  const payload = resData?.payload;
  if (!payload) return null;

  //整理数据
  const data = {
    page: payload.page + 1,
    pageSize: payload.page_size,
    totalCount: payload.total_count,
    pluginList: payload.plugin_list?.map((plugin) => {
      return {
        appId: plugin.app_id,
        module: plugin.module,
        aliasName: plugin.alias_name,
        info: plugin.info,
        installPath: plugin.install_path,
      };
    }),
  };
  logger.dataLog("分页获取插件信息列表：", data);
  return data;
};

// 根据appId获得插件信息
const getPluginInfoByAppId = async (appId) => {
  if (!appId && appId !== 0) return null;
  const resData = await api.queryPluginInfo(1, 0, {
    app_id: appId,
  });

  if (resData.code !== 0) {
    logger.error(
      "getPluginInfoByAppId code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error("根据appId查询插件信息失败");
  }

  const payload = resData?.payload;
  if (!payload || !payload.plugin_list) {
    logger.error(
      "未找到插件 getPluginInfoByAppId code：",
      resData.code,
      " resData: ",
      resData
    );
    return null;
  }

  //整理数据
  const data = {
    appId: payload.plugin_list[0].app_id,
    module: payload.plugin_list[0].module,
    aliasName: payload.plugin_list[0].alias_name,
    info: payload.plugin_list[0].info,
    installPath: payload.plugin_list[0].install_path,
  };
  logger.dataLog("根据appId获取插件信息：", data);
  return data;
};

const loginFailCodeMap = {
  3: "用户名或密码不能为空",
  5: "未找到该用户",
  10: "密码错误",
};

// 登陆 获取授权 返回用户名 登录时间 token
const getAuthorization = async (userName, password) => {
  const resData = await api.login(userName, password);
  if (resData.code !== 0) {
    logger.error(
      "登录失败 , getAuthorization code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      loginFailCodeMap[resData.code] || `登录失败 ${resData.msg}`
    );
  }
  const payload = resData.payload;
  const data = {
    userName: payload?.username,
    token: payload?.authorization,
    loginDate: new Date(),
  };
  logger.dataLog("获取授权：", data);
  return data;
};

// 退出
const removeAuthorization = async () => {
  let resData = null
  resData = await api.logout(token);
  if (resData.code !== 0) {
    logger.error(
      "注销失败 , removeAuthorization code：",
      resData.code,
      " resData: ",
      resData
    );
  }
  logger.dataLog("退出登录", resData);
};

const failCodeMap = {
  3: "参数有误, 请检查和完善表单",
  5: "未找到该记录",
  6: "已存在，重复添加",
  // 10: "密码错误",
};

// 添加插件
const addPlugin = async ({ appId, module, installPath, info, aliasName }) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.addPlugin(token, {
    appId,
    module,
    installPath,
    info,
    aliasName,
  });
  if (resData.code !== 0) {
    logger.error(
      "插件添加失败 , addPlugin code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      failCodeMap[resData.code] || `插件添加失败： ${resData.msg}`
    );
  }
  const payload = resData.payload;
  const data = {
    pluginId: payload.key_id,
  };
  logger.dataLog("添加插件", data);
  return data;
};

// 删除插件
const deletePlugin = async (appId) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.deletePlugin(token, appId);
  if (resData.code !== 0) {
    logger.error(
      "插件删除失败 , deletePlugin code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(`插件删除失败： ${resData.msg}`);
  }
  logger.dataLog("删除插件： ", appId, resData);
  return null;
};

// 更新插件
const updatePlugin = async (targetAppId, plugin = {}) => {
  const { appId, module, installPath, info, aliasName } = plugin;
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.updatePlugin(token, {
    appId: targetAppId,
    newAppId: appId,
    module,
    installPath,
    info,
    aliasName,
  });
  if (resData.code !== 0) {
    logger.error(
      "插件更新失败 , updatePlugin code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(failCodeMap[resData.code] || `插件更新失败 ${resData.msg}`);
  }
  logger.dataLog("更新插件： ", targetAppId, module, plugin, resData);
  return null;
};

// 根据flag的过滤选项
const flagFilterItems = [
  { value: -1, desc: "全部" },
  // { value: 0, desc: "不参与筛选" },
  { value: 1, desc: "正式版" },
  { value: 2, desc: "测试版" },
];

const systemFilterItems = [
  { value: -1, desc: "全部" },
  { value: "windows", desc: "windows" },
  { value: "linux", desc: "linux" },
  { value: "linux-arm64", desc: "linux-arm64" },
  { value: "all", desc: "all" },
];
// 默认的flag过滤选项
const defaultFlagFilterItem = flagFilterItems[0];
const defaultSystemFilterItems = systemFilterItems[0];
// 获取某个插件的版本列表 和模糊匹配
const getPluginVerListByAppId = async ({
  pluginAppId,
  pageSize,
  currentPage,
  keyword = "",
  // 参考 flagFilterItems
  publishFlag = -1,
  publishTimeStart = "",
  publishTimeEnd = "",
  systemFilter = -1
}) => {
  let resData = {};
  let filter = {
    plugin_app_id: pluginAppId,
    match: keyword,
  };
  // 同时存在发布时间的区间时 携带publish_time_start和end参数
  if (publishTimeStart && publishTimeEnd) {
    // 转为utc时间
    filter.publish_time_start = date.cstToUtcNumber(publishTimeStart);
    filter.publish_time_end = date.cstToUtcNumber(publishTimeEnd);
  }
  if(systemFilter !== -1) {
    filter.system = systemFilter;
  }
  // 如果不是负数， 则需要筛选正式版和测试版
  if (publishFlag >= 0) {
    filter.publish_flag = publishFlag;
    resData = await api.queryPluginVer(pageSize, currentPage - 1, filter);
  } else {
    resData = await api.queryPluginVer(pageSize, currentPage - 1, filter);
  }

  if (resData.code !== 0) {
    logger.error(
      "getPluginVerListByName code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error("查询插件" + pluginAppId + "版本列表失败");
  }

  const payload = resData?.payload;
  if (!payload) return null;

  //整理数据
  const data = {
    page: payload.page + 1,
    pageSize: payload.page_size,
    totalCount: payload.total_count,
    pluginVerList: payload.plugin_ver_list?.map((pluginVer) => {
      return {
        id: pluginVer.id,
        pluginAppId: pluginVer.plugin_app_id,
        version: pluginVer.version,
        buildTime: pluginVer.build_time,
        pluginVerHash: pluginVer.plugin_ver_hash,
        changeInfo: pluginVer.change_info,
        changeInfoEn: pluginVer.change_info_en,
        // 服务器里的时间戳为utc时间戳 北京时间比UTC时间早8小时
        publishTime: date.utcToCst(pluginVer.publish_time),
        publishFlag: pluginVer.publish_flag,
        fileId: pluginVer.file_id,
        fileSize: pluginVer.file_size,
        fileName: pluginVer.file_name,
        fileHash: pluginVer.file_hash,
        depPluginVerList: pluginVer.dep_plugin_ver_list?.map((depPluginVer) => {
          return {
            id: depPluginVer.id,
            pluginName: depPluginVer.plugin_name,
            version: depPluginVer.version,
            buildTime: depPluginVer.build_time,
          };
        }),
        publishSystem: pluginVer.system,
      };
    }),
  };
  logger.dataLog("分页获取某个插件的版本列表：", data, pluginAppId);
  return data;
};

const getHistoryVer = async ({
  pluginAppId,
  pageSize,
  currentPage,
  keyword = "",
  // 参考 flagFilterItems
  publishFlag = -1,
  publishTimeStart = "",
  publishTimeEnd = "",
  systemFilter = -1
}) => {
  let resData = {};
  let filter = {
    plugin_app_id: pluginAppId,
    match: keyword
  };
  // 同时存在发布时间的区间时 携带publish_time_start和end参数
  if (publishTimeStart && publishTimeEnd) {
    // 转为utc时间
    filter.publish_time_start = date.cstToUtcNumber(publishTimeStart);
    filter.publish_time_end = date.cstToUtcNumber(publishTimeEnd);
  }
  if(systemFilter !== -1) {
    filter.system = systemFilter;
  }
  // 如果不是负数， 则需要筛选正式版和测试版
  if (publishFlag >= 0) {
    filter.publish_flag = publishFlag;
    resData = await api.queryPluginVer(pageSize, currentPage - 1, filter);
  } else {
    resData = await api.queryPluginVer(pageSize, currentPage - 1, filter);
  }

  if (resData.code !== 0) {
    logger.error(
      "getPluginVerListByName code：",
      resData.code,
      " resData: ",
      resData
    );
    // throw new Error("查询插件" + pluginAppId + "版本列表失败");
  }

  const payload = resData?.payload;
  if (!payload) return null;

  //整理数据
  const data = {
    page: payload.page + 1,
    pageSize: payload.page_size,
    totalCount: payload.total_count,
    pluginVerList: payload.plugin_ver_list?.map((pluginVer) => {
      return {
        id: pluginVer.id,
        pluginAppId: pluginVer.plugin_app_id,
        version: pluginVer.version,
        buildTime: pluginVer.build_time,
        pluginVerHash: pluginVer.plugin_ver_hash,
        changeInfo: pluginVer.change_info,
        changeInfoEn: pluginVer.change_info_en,
        // 服务器里的时间戳为utc时间戳 北京时间比UTC时间早8小时
        publishTime: date.utcToCst(pluginVer.publish_time),
        publishFlag: pluginVer.publish_flag,
        fileId: pluginVer.file_id,
        fileSize: pluginVer.file_size,
        fileName: pluginVer.file_name,
        fileHash: pluginVer.file_hash,
        depPluginVerList: pluginVer.dep_plugin_ver_list?.map((depPluginVer) => {
          return {
            id: depPluginVer.id,
            pluginName: depPluginVer.plugin_name,
            version: depPluginVer.version,
            buildTime: depPluginVer.build_time,
          };
        }),
        publishSystem: pluginVer.system,
      };
    }),
  };
  // logger.dataLog("分页获取某个插件的版本列表：", data, pluginAppId);
  return data;
};

// 查询所有的历史版本列表
// const getHistoryVer = () => {
//   return api.getHistoryVer();
// }

// 模糊匹配全部的版本列表
const searchPluginVerList = async (pageSize, currentPage, keyword = "") => {
  let resData = {};
  const filter = { match: keyword };
  resData = await api.queryPluginVer(pageSize, currentPage - 1, filter);

  if (resData.code !== 0) {
    logger.error(
      "searchPluginVerList code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error("模糊匹配全部的版本列表" + keyword + "版本列表失败");
  }

  const payload = resData?.payload;
  if (!payload) return null;

  //整理数据
  const data = {
    page: payload.page + 1,
    pageSize: payload.page_size,
    totalCount: payload.total_count,
    pluginVerList: payload.plugin_ver_list?.map((pluginVer) => {
      return {
        id: pluginVer.id,
        pluginName: pluginVer.plugin_name,
        version: pluginVer.version,
        buildTime: pluginVer.build_time,
        pluginVerHash: pluginVer.plugin_ver_hash,
        changeInfo: pluginVer.change_info,
        // 服务器里的时间戳为utc时间戳 北京时间比UTC时间早8小时
        publishTime: date.utcToCst(pluginVer.publish_time),
        publishFlag: pluginVer.publish_flag,
        fileId: pluginVer.file_id,
        fileSize: pluginVer.file_size,
        fileName: pluginVer.file_name,
        fileHash: pluginVer.file_hash,
        depPluginVerList: pluginVer.dep_plugin_ver_list?.map((depPluginVer) => {
          return {
            id: depPluginVer.id,
            pluginName: depPluginVer.plugin_name,
            version: depPluginVer.version,
            buildTime: depPluginVer.build_time,
          };
        }),
        publishSystem: pluginVer.system,
      };
    }),
  };
  logger.dataLog("模糊匹配全部的版本列表", data, keyword);
  return data;
};

// 添加插件版本
const addPluginVer = async ({
  pluginAppId,
  fileId,
  buildTime,
  changeInfo,
  publishFlag,
  version,
  pluginVerHash,
  publishSystem,
}) => {
  if (!token) {
    logger.error("未登陆");
  }
  // const publishTime = new Date().valueOf();
  const resData = await api.addPluginVer(token, {
    pluginAppId,
    fileId,
    buildTime,
    changeInfo,
    publishFlag,
    version,
    pluginVerHash,
    publishSystem,
  });
  if (resData.code !== 0) {
    logger.error(
      "插件版本添加失败 , addPluginVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      failCodeMap[resData.code] || `插件版本添加失败 ${resData.msg}`
    );
  }
  const payload = resData.payload;
  const data = {
    pluginVerId: payload.key_id,
  };
  logger.dataLog("添加插件版本", data);
  return data;
};

// 更新插件版本
const updatePluginVer = async (id, pluginVer = {}) => {
  let {
    fileId,
    buildTime,
    pluginVerHash,
    changeInfo,
    changeInfoEn,
    version,
    publishFlag,
    publishSystem,
  } = pluginVer;
  if (!token) {
    logger.error("未登陆");
  }
  // const publishTime = new Date().valueOf();
  if( typeof fileId !== 'string') {
    fileId = fileId[0]
    publishSystem = publishSystem[0]
  }
  const resData = await api.updatePluginVer(
    token,
    id,
    fileId,
    buildTime,
    changeInfo,
    changeInfoEn,
    version,
    publishFlag,
    pluginVerHash,
    publishSystem
  );
  if (resData.code !== 0) {
    logger.error(
      "插件版本更新失败 , updatePluginVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      failCodeMap[resData.code] || `插件版本更新失败 ${resData.msg}`
    );
  }
  logger.dataLog("更新插件： ", id, pluginVer, resData);
  return null;
};

// 删除插件版本
const deletePluginVer = async (id) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.deletePluginVer(token, id);
  if (resData.code !== 0) {
    logger.error(
      "插件版本删除失败 , deletePluginVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(`插件版本删除失败： ${resData.msg}`);
  }
  logger.dataLog("删除插件版本： ", id, resData);
  return null;
};

// 添加插件版本依赖 addPluginVerDep
const addPluginVerDep = async (id, depId) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.addPluginVerDep(token, id, depId);
  if (resData.code !== 0) {
    logger.error(
      "插件版本依赖添加失败 , addPluginVerDep code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(`插件版本依赖添加失败 ${resData.msg}`);
  }
  logger.dataLog("添加插件版本依赖 ", id, depId, resData);
  return null;
};

// 删除插件版本依赖 deletePluginVerDep
const deletePluginVerDep = async (id, depId) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.deletePluginVerDep(token, id, depId);
  if (resData.code !== 0) {
    logger.error(
      "插件版本依赖删除失败 , deletePluginVerDep code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(`插件版本依赖删除失败： ${resData.msg}`);
  }
  logger.dataLog("删除插件版本依赖： ", id, depId, resData);
  return null;
};

// 上传文件
const uploadFile = async (
  file,
  cancelToken,
  onUpload = (percent, loaded, total) => {}
) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.uploadFile(token, file, cancelToken, onUpload);
  if (resData.code !== 0) {
    logger.error(
      "上传文件失败 , uploadFile code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error("上传文件失败");
  }
  const payload = resData.payload;
  const data = {
    fileId: payload.file_id,
  };
  logger.dataLog("上传文件 ", file, data);
  return data;
};

// 下载文件 downloadFile
const downloadFile = async (fileId, fileName) => {
  const resData = await api.downloadFile(fileId);
  const blob = new Blob([resData], { type: "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.download = fileName;
  a.href = url;
  // a.target = "_blank";
  // a.rel = "noopener noreferer";
  a.click();
  // 下载完毕，释放
  a.onload = function () {
    window.URL.revokeObjectURL(url);
    a.remove();
  };
  logger.dataLog("下载文件： ", fileId, fileName);
  return null;
};

// 直接获取下载文件的url
export function getDownloadFileUrl(fileId) {
  return api.getDownloadFileUrl(fileId);
}

// 删除文件
const deleteFile = async (fileId) => {
  if (!token) {
    logger.error("未登陆");
  }
  const resData = await api.deleteFile(token, fileId);
  if (resData.code !== 0) {
    logger.error(
      "文件删除失败 , deletePluginVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(`文件删除失败： ${resData.msg}`);
  }
  logger.dataLog("删除文件： ", fileId, resData);
  return null;
};

const publishFlagOptions = [
  // {
  //   value: 0,
  //   desc: "不参与赛选",
  // },
  {
    value: 1,
    desc: "正式版",
  },
  {
    value: 2,
    desc: "测试版",
  },
];

const publishSystem = [
  { value: "windows", desc: "windows" },
  { value: "linux", desc: "linux" },
  { value: "linux-arm64", desc: "linux-arm64" },
  { value: "all", desc: "all" },
];

const getFlagValueBydesc = (flagDesc) => {
  let flagValue = 0;
  publishFlagOptions.forEach((o) => {
    if (o.desc === flagDesc) {
      flagValue = o.value;
    }
  });
  return flagValue;
};

// 根据转换之后的file_id上传版本到服务器,需要的参数(build_time,change_info,file_id,plugin_app_id,publish_flag,version,plugin_ver_hash)
const uploadVersion = (json_info,file_id) => {
  // 这里会传入token来验证
  return api.uploadVersion(token,json_info,file_id)
}

// 上传多版本文件, 文件上传转换为file_id, 然后根据接收到文件上传和版本信息来上传到服务器 file就是版本的zip文件 json就是版本对应的版本信息
const uploadVersionFile = async (file, json) => {
      let status = 0  // 0 代表未上传 1 代表上传中 2 代表上传完成 3 代表文件上传失败 4 代表版本发布失败
      // 发起请求上传文件，拿到返回的file_id,然后就发起请求添加依赖
      let fileId = null
      status = 1
      try {
        // 发起请求把文件上传到服务器得到file_id
        const { payload : { file_id },code,msg} = await api.uploadVersionFile(token, file)
        if(code !== 0) {
          status = 3
          return notifier.error(msg)
        }
        fileId = file_id
      } catch(e) {
        console.log('文件上传失败',e);
        notifier.error(e.message)
        return status = 3
      }
      try {
        // 使用得到的file_id去发布版本到服务器
        const res = await uploadVersion(json,fileId)
        if(res.code === 0){
          status = 2
          console.log('上传版本返回的信息',res);
        }else {
          // 如果发布的版本已经存在 直接提示版本已经存在 并且返回状态为版本发布失败 status = 4
          status = 4
          switch(res.code) {
            case 6:
              notifier.error('插件版本已经存在，请勿重复上传！')
              break
            default:
              notifier.error(res.msg)
          }
          return status
        }
      } catch(e) {
        console.log('版本发布失败',e);
        return status = 4
      }
      return status
// api.uploadVersionFile就是传递一个文件，返回一个文件id就是file_id
}
// 查询没有发布版本的插件
const queryPluginNoVer = async () => {
  const resData = await api.queryPluginNoVer(token)

  if (resData.code !== 0) {
    logger.error(
      "查询没有发布版本的插件失败 , queryPluginNoVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      failCodeMap[resData.code] || `查询没有发布版本的插件失败 ${resData.msg}`
    );
  }
  return resData;
}
// 查询过期插件版本列表
const getOvertimePluginVer = async (reserveCount) => {
  const resData = await api.getOvertimePluginVer(token,reserveCount)

  if (resData.code !== 0) {
    logger.error(
      "查询过期插件版本列表失败 , getOvertimePluginVer code：",
      resData.code,
      " resData: ",
      resData
    );
    throw new Error(
      failCodeMap[resData.code] || `查询过期插件版本列表失败 ${resData.msg}`
    );
  }
  const { payload } = resData
  const data = {
    pluginVerList: payload.plugin_ver_list?.map((pluginVer) => {
      return {
        id: pluginVer.id,
        pluginAppId: pluginVer.plugin_app_id,
        version: pluginVer.version,
        buildTime: pluginVer.build_time,
        pluginVerHash: pluginVer.plugin_ver_hash,
        changeInfo: pluginVer.change_info,
        changeInfoEn: pluginVer.change_info_en,
        // 服务器里的时间戳为utc时间戳 北京时间比UTC时间早8小时
        publishTime: date.utcToCst(pluginVer.publish_time),
        publishFlag: pluginVer.publish_flag,
        fileId: pluginVer.file_id,
        fileSize: pluginVer.file_size,
        fileName: pluginVer.file_name,
        fileHash: pluginVer.file_hash,
        depPluginVerList: pluginVer.dep_plugin_ver_list?.map((depPluginVer) => {
          return {
            id: depPluginVer.id,
            pluginName: depPluginVer.plugin_name,
            version: depPluginVer.version,
            buildTime: depPluginVer.build_time,
          };
        }),
        publishSystem: pluginVer.system,
      };
    }),
  };
  return data;
}



const data = {
  publishFlagOptions,
  publishSystem,
  flagFilterItems,
  systemFilterItems,
  defaultSystemFilterItems,
  defaultFlagFilterItem,
  getFlagValueBydesc,
  getPluginInfoList,
  getPluginInfoByAppId,
  getAuthorization,
  removeAuthorization,
  setToken,
  removeToken,
  addPlugin,
  deletePlugin,
  updatePlugin,
  getPluginVerListByAppId,
  searchPluginVerList,
  addPluginVer,
  updatePluginVer,
  deletePluginVer,
  addPluginVerDep,
  deletePluginVerDep,
  uploadFile,
  downloadFile,
  getDownloadFileUrl,
  deleteFile,
  uploadVersionFile,
  uploadVersion,
  getHistoryVer,
  queryPluginNoVer,
  getOvertimePluginVer
};

export default data;
